// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__123AG","label":"styles_label__2IJ7N"};